import { Skeleton } from '@zorro/design-system/v2/Skeleton';
import { CsvFileIcon } from '@zorro/shared/assets';
import { Box, Icon } from '@zorro/web/design-system';
import { useMonolithQuery } from '@zorro/web/ui-utils';

import { exportAllowanceModelToCsv } from '../../PlanYearSetupForm/PlanYearSetupUtils';
import { NO_DATA_PLACEHOLDER } from '../planYearTable.consts';

type AllowanceModelCellProps = {
  employerId: string;
  employerName: string;
  year: string;
};

const AllowanceModelCell = ({
  employerId,
  employerName,
  year,
}: AllowanceModelCellProps) => {
  const { data: allowanceModel, isLoading: isLoadingAllowanceModel } =
    useMonolithQuery({
      method: 'allowanceModelControllerSearch',
      params: [employerId, { year: Number(year) }],
    });

  if (isLoadingAllowanceModel) {
    return <Skeleton height={26} />;
  }

  if (!allowanceModel) {
    return NO_DATA_PLACEHOLDER;
  }

  return (
    <Box
      onClick={() => exportAllowanceModelToCsv(allowanceModel, employerName)}
      style={{ cursor: 'pointer' }}
    >
      <Icon icon={CsvFileIcon} />
    </Box>
  );
};

export { AllowanceModelCell };
